import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import Adhesion from '../../../atoms/adhesion';
// import CardResource from '../../../molecules/profile/card-resource';
// import CardResourceContainer from '../../../molecules/profile/card-resource-container';
import FeesAndExpenses from '../../../molecules/profile/fees-and-expenses';
import FooterDisclosures from '../../../atoms/footer-disclosures';
import HeaderQuoteBar from '../../../molecules/profile/header-quote-bar';
import InvestmentFacts from '../../../molecules/profile/investment-facts';
import ModelStrategy from '../../../molecules/profile/model-strategy';
import PageHeader from '../../../molecules/profile/page-header';
import PageMain from '../../../molecules/profile/page-main';
import PageSideRail, { DisclosurePrint } from '../../../molecules/profile/page-side-rail';
import PerformanceReturns from '../../../molecules/profile/performance-returns';
import SectionDivider from '../../../atoms/section-divider';
import TemplateSectionDisclosure from '../../../atoms/template-section-disclosures';
import TextModule from '../../../molecules/profile/text-module';
import UnderlyingInvestments from '../../../molecules/profile/underlying-investments';
import feesAndExpensesText from '../../../../helpers/statics/fees-and-expenses-text';
import retirePlusModelStrategyText from '../../../../helpers/statics/retireplus-model-strategy-text';
import sectionDividerOptions from '../../../../helpers/statics/section-divider-options';
import transformInvestmentFacts from '../../../../stores/profile/modules/transform-investment-facts';
import useRetirePlusStore from '../../../../stores/profile/use-retire-plus-store';
// import { FUND_TYPES } from '../../../../stores/profile/get-fund-type';
import { className } from '../../../../utils/GlobalCssProxy';
import { returnExpenseExample } from '../../../../helpers/dynamic/expense-example';
// import { getIsDynamicGreetingShown } from '../../../molecules/profile/dynamic-greeting/dynamic-greeting-helper';
import useDetectPrint from 'react-detect-print';

const Other = () => {
  const store = useRetirePlusStore();
  const quoteData = store.quote.isLoaded ? store.quote.data : {};
  const xrefData = store.xref.isLoaded ? store.xref.data : {};
  const expenseExample = returnExpenseExample(quoteData.expenseExample);
  const participantHoldingsData =
    store.participantHoldings && store.participantHoldings.isLoaded
      ? store.participantHoldings.data
      : {};
  const showDynamicGreeting = false; // TIAA-12449 disable retire select/pro dynamic greeting
  //const showDynamicGreeting = participantHoldingsData && getIsDynamicGreetingShown(participantHoldingsData);

  const disclosureList = store.disclosureList.isLoaded ? store.disclosureList.data : [];
  const preRenderedModelStrategy = (
    <ModelStrategy
      heading="Model Strategy"
      bodyText={quoteData.modelStrategy}
      buttonText={retirePlusModelStrategyText.buttonText}
    />
  );

  const printing = useDetectPrint();

  return (
    <div data-template="RetirePlus">
      <PageHeader
        displayAsFundType="RetirePlus Model Portfolio"
        sectionNavOptions={[
          sectionDividerOptions.performance,
          sectionDividerOptions.allocation,
          sectionDividerOptions.characteristics
        ]}
        showDisclosuresButton={true}
      >
        <HeaderQuoteBar>
          <HeaderQuoteBar.GrossNetExpenseRatio
            grossValue={quoteData.grossExpenseRatio}
            netValue={quoteData.netExpenseRatio}
            isRetirePlus={true}
          />
          <HeaderQuoteBar.AccountInceptionDate
            asOfDate={quoteData.inceptionDate}
            responsive={printing ? undefined : 1}
          />
          <HeaderQuoteBar.AssetClass responsive={printing ? undefined : 2}>
            {quoteData.assetClass}
          </HeaderQuoteBar.AssetClass>
        </HeaderQuoteBar>
      </PageHeader>
      <PageMain>
        <SectionDivider
          labelText={sectionDividerOptions.performance.label}
          id={sectionDividerOptions.performance.id}
          isDynamicGreetingShown={showDynamicGreeting}
          dynamicGreetingParticipantHoldings={participantHoldingsData}
        >
          <Row {...className('print-row-margin-bottom')}>
            <Col>
              <PerformanceReturns isRetirePlus={true} />
            </Col>
          </Row>
          <Row>
            <Col>
              <DisclosurePrint
                disclosureList={disclosureList.perfDisclosureModules}
                avoidPageBreak
              />
            </Col>
          </Row>
          <Row {...className('d-print-flex', 'print-row-margin-bottom')}>
            <Col md={4} {...className('col-print-6')}>
              <FeesAndExpenses
                expenses={store.feesExpenses.isLoaded ? store.feesExpenses.data : {}}
                fundType={store.fundType}
                heading="Fees &amp; Expenses"
                text={feesAndExpensesText.text}
              />
            </Col>
            <Col md={4} {...className('d-print-none')}>
              <Adhesion.Performance />
            </Col>
            <Col md={4} {...className('col-print-6')}>
              <TextModule
                moduleHeader="Expense Example"
                textHighlighted={expenseExample.textHighlighted}
                textNormal={expenseExample.textNormal}
              />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.allocation.label}
          id={sectionDividerOptions.allocation.id}
        >
          <Row>
            <Col>
              <UnderlyingInvestments />
            </Col>
          </Row>
          <Row>
            <Col>
              <TemplateSectionDisclosure section="allocation" />
            </Col>
          </Row>
        </SectionDivider>
        <SectionDivider
          labelText={sectionDividerOptions.characteristics.label}
          id={sectionDividerOptions.characteristics.id}
        >
          <Row
            {...className(
              'd-print-flex',
              'avoid-page-break',
              'h-print-auto',
              'print-characteristics'
            )}
          >
            <Col md={8} {...className('col-print-4')}>
              <TextModule
                moduleHeader="Who May Want to Invest"
                textNormal={
                  store.investmentFacts.isLoaded && store.investmentFacts.data.whoMayWantToInvest
                    ? store.investmentFacts.data.whoMayWantToInvest
                    : ''
                }
                disablePrintSizeClass={true}
              />
            </Col>
            <Col md={4} {...className('col-print-4')}>
              <InvestmentFacts
                header="Investment Facts"
                headerAsOfDate={
                  store.investmentFacts.isLoaded && store.investmentFacts.data.retirePlusAsOfDate
                    ? store.investmentFacts.data.retirePlusAsOfDate
                    : ''
                }
                facts={
                  store.investmentFacts.isLoaded
                    ? transformInvestmentFacts(
                      store.investmentFacts.data,
                      store.fundType,
                      store.assetClass
                    )
                    : [] // prettier-ignore
                }
                ticker={xrefData.symbol ? xrefData.symbol : null}
              ></InvestmentFacts>
            </Col>
            {/* Print only to save space*/}
            <Col {...className('d-none', 'd-print-block', 'col-print-4')}>
              {preRenderedModelStrategy}
            </Col>
          </Row>
          <Row {...className('d-print-none')}>
            <Col md={6}>
              <Adhesion.Characteristics />
            </Col>
            <Col md={6}>
              <ModelStrategy
                heading="Model Strategy"
                bodyText={quoteData.modelStrategy || ''}
                buttonText={retirePlusModelStrategyText.buttonText}
              />
            </Col>
          </Row>
        </SectionDivider>

        <FooterDisclosures />
        <div {...className('admaster-number', 'd-print-none')}>4347056</div>
        <DisclosurePrint disclosureList={disclosureList.disclosureModules} admasterNumber="4347056" />
      </PageMain>
      <PageSideRail printDisclosures={false} />
    </div>
  );
};

export default Other;
